{
  "hello": "สวัสดี",
  "nav": {
    "home": "หน้าแรก",
    "convert": "แลกเปลี่ยน",
    "c2c": "ซื้อขายเหรียญ",
    "c2cTab": {
      "buy": "ต้องการซื้อ",
      "sell": "ต้องการขาย"
    },
    "orderList": "คำสั่งซื้อ",
    "orderTab": {
      "buy": "ซื้อเหรียญ",
      "sell": "ขายเหรียญ",
      "fastTrack": "ธุรกรรมด่วน",
      "open": "คำสั่งซื้อที่กำลังดำเนินการ",
      "closed": "ประวัติคำสั่งซื้อ"
    },
    "my": "ของฉัน"
  },
  "hi": "สวัสดี 👋",
  "introCustomerService": "สวัสดี ยินดีต้อนรับสู่ศูนย์บริการลูกค้า ทีมงานของเราพร้อมช่วยเหลือคุณเสมอ มีอะไรให้เราช่วยไหม",
  "startConversation": "เริ่มการสนทนาใหม่",
  "responseTime": "เวลาโดยทั่วไปที่เราตอบกลับ",
  "fewMinutes": "ไม่กี่นาที",
  "sendUsMessage": "ส่งข้อความถึงเรา",
  "yourConversation": "การสนทนาของคุณ",
  "cancel": "ยกเลิก"
}
